var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7412_1641)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36476 34.6236C0.257611 26.254 10.3255 26.4813 17.4969 20.6832C23.686 15.6791 34.3661 8.46063 42.4499 12.1975C51.935 16.5822 52.1492 23.6973 51.4499 29.1979C50.291 38.3141 42.6821 45.5053 32.5979 46.3276C22.9597 47.1135 10.3164 42.7383 5.36476 34.6236Z",
    fill: "#EDF9D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9134 50.6746V45.3485C49.9134 42.5233 48.7911 39.8139 46.7934 37.8162C44.7958 35.8186 42.0863 34.6963 39.2612 34.6963H17.9569C15.1317 34.6963 12.4223 35.8186 10.4246 37.8162C8.42697 39.8139 7.30469 42.5233 7.30469 45.3485V50.6746",
    stroke: "#A2CD3A",
    strokeWidth: 3.65217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6092 27.3913C34.4922 27.3913 39.2614 22.6221 39.2614 16.7391C39.2614 10.8561 34.4922 6.08691 28.6092 6.08691C22.7262 6.08691 17.957 10.8561 17.957 16.7391C17.957 22.6221 22.7262 27.3913 28.6092 27.3913Z",
    stroke: "#29ABE2",
    strokeWidth: 3.65217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7379 34.6963L37.7392 42.0006L40.3031 34.6963H28.7379ZM28.7379 34.6963L20.087 42.0006L17.1727 34.6963H28.7379Z",
    stroke: "#29ABE2",
    strokeWidth: 3.65217,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7412_1641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccount);
export default __webpack_public_path__ + "static/media/ic-account.4e0c861c6463e0334016ce898baa303a.svg";
export { ForwardRef as ReactComponent };